angular.module('meanApp')
  .controller('howtouse-controller', function ($scope) {

    $scope.loadingMessage = "Loading...";
    $scope.isHowtoUse = true;

  });